import React from 'react';
import { useParams } from 'react-router-dom';
import DetailPaymentComponent from "../../../components/Admin/payments/DetailPaymentComponent";

const DetailPaymentPage = () => {
    const params = useParams()
    return <DetailPaymentComponent paymentId={ params.paymentId } />;
}

export default DetailPaymentPage;